export default __webpack_public_path__ + "static/media/heroanimation2.b61831dd.png";